/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApprovedChangeRequestSearchRequest } from '../models/ApprovedChangeRequestSearchRequest';
import type { ApprovedChangeRequestSearchResponse } from '../models/ApprovedChangeRequestSearchResponse';
import type { ChangeRequestApplyRequest } from '../models/ChangeRequestApplyRequest';
import type { ChangeRequestApprovedMailRequest } from '../models/ChangeRequestApprovedMailRequest';
import type { ChangeRequestApproveRequests } from '../models/ChangeRequestApproveRequests';
import type { ChangeRequestCompetitorCreateRequest } from '../models/ChangeRequestCompetitorCreateRequest';
import type { ChangeRequestCompetitorUpdateRequest } from '../models/ChangeRequestCompetitorUpdateRequest';
import type { ChangeRequestContinueCreateRequest } from '../models/ChangeRequestContinueCreateRequest';
import type { ChangeRequestDeleteApprovedRequest } from '../models/ChangeRequestDeleteApprovedRequest';
import type { ChangeRequestDeleteForHeadquarterRequest } from '../models/ChangeRequestDeleteForHeadquarterRequest';
import type { ChangeRequestDeleteRequest } from '../models/ChangeRequestDeleteRequest';
import type { ChangeRequestDuplicateCheckRequest } from '../models/ChangeRequestDuplicateCheckRequest';
import type { ChangeRequestFlyerCreateRequest } from '../models/ChangeRequestFlyerCreateRequest';
import type { ChangeRequestFreshnessCreateRequest } from '../models/ChangeRequestFreshnessCreateRequest';
import type { ChangeRequestFreshnessUpdateRequest } from '../models/ChangeRequestFreshnessUpdateRequest';
import type { ChangeRequestInstructionCreateRequest } from '../models/ChangeRequestInstructionCreateRequest';
import type { ChangeRequestInstructionUpdateRequest } from '../models/ChangeRequestInstructionUpdateRequest';
import type { ChangeRequestResponse } from '../models/ChangeRequestResponse';
import type { ChangeRequestUpdateRequest } from '../models/ChangeRequestUpdateRequest';
import type { ChangeRequestUpdatesRequest } from '../models/ChangeRequestUpdatesRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChangeRequestControllerService {
    /**
     * @param competitorStoreMasterId
     * @param storeRank
     * @returns any OK
     * @throws ApiError
     */
    public static updateStoreRank(
        competitorStoreMasterId: number,
        storeRank: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/competitor/store-rank/{competitorStoreMasterId}',
            path: {
                'competitorStoreMasterId': competitorStoreMasterId,
            },
            query: {
                'storeRank': storeRank,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static validateUpdateChangeRequests(
        requestBody?: ChangeRequestUpdatesRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/change-request/validates',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param changeRequestId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static validateUpdateChangeRequest(
        changeRequestId: number,
        requestBody?: ChangeRequestUpdateRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/change-request/validate/{changeRequestId}',
            path: {
                'changeRequestId': changeRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param changeRequestId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updateChangeRequestInstruction(
        changeRequestId: number,
        requestBody: ChangeRequestInstructionUpdateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/change-request/instruction/{changeRequestId}',
            path: {
                'changeRequestId': changeRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param changeRequestId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updateChangeRequestFreshness(
        changeRequestId: number,
        requestBody: ChangeRequestFreshnessUpdateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/change-request/freshness/{changeRequestId}',
            path: {
                'changeRequestId': changeRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param changeRequestId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updateChangeRequestCompetitor(
        changeRequestId: number,
        requestBody: ChangeRequestCompetitorUpdateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/change-request/competitor/{changeRequestId}',
            path: {
                'changeRequestId': changeRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns number OK
     * @throws ApiError
     */
    public static approve(
        requestBody: ChangeRequestApproveRequests,
    ): CancelablePromise<Array<number>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/change-request/approve',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static apply(
        requestBody: ChangeRequestApplyRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/change-request/apply',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static validateChangeRequestInstruction(
        requestBody: Array<ChangeRequestInstructionCreateRequest>,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/change-request/validate/INSTRUCTION',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static validateChangeRequestFreshness(
        requestBody: Array<ChangeRequestFreshnessCreateRequest>,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/change-request/validate/FRESHNESS',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static validateChangeRequestCompetitor(
        requestBody: Array<ChangeRequestCompetitorCreateRequest>,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/change-request/validate/COMPETITOR',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param registrationMethod
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createChangeRequestInstruction(
        registrationMethod: 'EXCEL' | 'FORM' | 'CONTINUATION' | 'HT_API' | 'CONVERSION',
        requestBody: Array<ChangeRequestInstructionCreateRequest>,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/change-request/instruction/{registrationMethod}',
            path: {
                'registrationMethod': registrationMethod,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param registrationMethod
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createChangeRequestFreshness(
        registrationMethod: 'EXCEL' | 'FORM' | 'CONTINUATION' | 'HT_API' | 'CONVERSION',
        requestBody: Array<ChangeRequestFreshnessCreateRequest>,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/change-request/freshness/{registrationMethod}',
            path: {
                'registrationMethod': registrationMethod,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param registrationMethod
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public static createChangeRequestFlyer(
        registrationMethod: 'EXCEL' | 'FORM' | 'CONTINUATION' | 'HT_API' | 'CONVERSION',
        requestBody: Array<ChangeRequestFlyerCreateRequest>,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/change-request/flyer/{registrationMethod}',
            path: {
                'registrationMethod': registrationMethod,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param changeRequestType
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static checkDuplicateChangeRequest(
        changeRequestType: 'COMPETITOR' | 'FRESHNESS' | 'INSTRUCTION' | 'FLYER',
        requestBody: Array<ChangeRequestDuplicateCheckRequest>,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/change-request/duplicate/{changeRequestType}',
            path: {
                'changeRequestType': changeRequestType,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static createChangeRequestContinuation(
        requestBody: ChangeRequestContinueCreateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/change-request/continuation',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param registrationMethod
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createChangeRequestCompetitor(
        registrationMethod: 'EXCEL' | 'FORM' | 'CONTINUATION' | 'HT_API' | 'CONVERSION',
        requestBody: Array<ChangeRequestCompetitorCreateRequest>,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/change-request/competitor/{registrationMethod}',
            path: {
                'registrationMethod': registrationMethod,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ApprovedChangeRequestSearchResponse OK
     * @throws ApiError
     */
    public static getChangeRequestsApproved(
        requestBody: ApprovedChangeRequestSearchRequest,
    ): CancelablePromise<ApprovedChangeRequestSearchResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/change-request/approved',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApprovedChangeRequest(
        requestBody: ChangeRequestDeleteApprovedRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/change-request/approved',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static sendApprovedMail(
        requestBody: ChangeRequestApprovedMailRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/change-request/approve/mail',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param changeRequestType
     * @param confirmStatus
     * @param requestedDate
     * @param page
     * @param limit
     * @param sortField
     * @param sortType
     * @returns ChangeRequestResponse OK
     * @throws ApiError
     */
    public static getChangeRequests(
        changeRequestType: 'COMPETITOR' | 'FRESHNESS' | 'INSTRUCTION' | 'FLYER',
        confirmStatus: 'REQUESTING' | 'NOT_CONFIRM' | 'CONFIRMED' | 'REMAND',
        requestedDate?: string,
        page: number = 1,
        limit: number = 20,
        sortField: string = 'id',
        sortType?: 'ASC' | 'DESC',
    ): CancelablePromise<ChangeRequestResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/change-request',
            query: {
                'changeRequestType': changeRequestType,
                'confirmStatus': confirmStatus,
                'requestedDate': requestedDate,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortType': sortType,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static deleteChangeRequest(
        requestBody: ChangeRequestDeleteRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/change-request',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static getIsAllowChangeRequestWithoutValidation(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/change-request/is-allow-validate',
        });
    }
    /**
     * @param changeRequestType
     * @param changeRequestIds
     * @returns ChangeRequestResponse OK
     * @throws ApiError
     */
    public static getChangeRequestsByIds(
        changeRequestType: 'COMPETITOR' | 'FRESHNESS' | 'INSTRUCTION' | 'FLYER',
        changeRequestIds: Array<number>,
    ): CancelablePromise<ChangeRequestResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/change-request/ids',
            query: {
                'changeRequestType': changeRequestType,
                'changeRequestIds': changeRequestIds,
            },
        });
    }
    /**
     * @param confirmStatus
     * @param competitorChainCode
     * @param competitorStoreCode
     * @param nearbyStoreCode
     * @param confirmRequestId
     * @param page
     * @param limit
     * @param sortField
     * @param sortType
     * @returns ChangeRequestResponse OK
     * @throws ApiError
     */
    public static getChangeRequestsNearbyStores(
        confirmStatus: 'REQUESTING' | 'NOT_CONFIRM' | 'CONFIRMED' | 'REMAND',
        competitorChainCode?: string,
        competitorStoreCode?: string,
        nearbyStoreCode?: string,
        confirmRequestId?: string,
        page: number = 1,
        limit: number = 20,
        sortField: string = 'id',
        sortType?: 'ASC' | 'DESC',
    ): CancelablePromise<ChangeRequestResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/change-request/competitor/nearby-store',
            query: {
                'confirmStatus': confirmStatus,
                'competitorChainCode': competitorChainCode,
                'competitorStoreCode': competitorStoreCode,
                'nearbyStoreCode': nearbyStoreCode,
                'confirmRequestId': confirmRequestId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortType': sortType,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApprovedChangeRequestForHeadquarter(
        requestBody: ChangeRequestDeleteForHeadquarterRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/change-request/approved/headquarter',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApprovedChangeRequestForFlyer(
        requestBody: Array<number>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/change-request/approved-for-flyer',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
